exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-data-bank-create-dataset-___licenses__container___3P4cl {\n  display: flex;\n  font-size: 14px;\n  align-items: center;\n}\n\n.src-components-data-bank-create-dataset-___licenses__description___1cV2O {\n  flex: 1;\n}\n\n.src-components-data-bank-create-dataset-___licenses__age___29ha3,\n.src-components-data-bank-create-dataset-___licenses__cost___3LChg {\n  width: 160px;\n  padding-right: 50px;\n  line-height: 18px;\n  text-align: right;\n}\n\n.src-components-data-bank-create-dataset-___licenses__age___29ha3 input,\n.src-components-data-bank-create-dataset-___licenses__cost___3LChg input {\n  text-align: right;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-data-bank-create-dataset-___licenses__container___3P4cl",
	"description": "src-components-data-bank-create-dataset-___licenses__description___1cV2O",
	"age": "src-components-data-bank-create-dataset-___licenses__age___29ha3",
	"cost": "src-components-data-bank-create-dataset-___licenses__cost___3LChg"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/data-bank/create/dataset/licenses.scss
// module id = 2304
// module chunks = 0